import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewEncapsulation
} from '@angular/core';
import { ReadMoreContext } from '../read-more-icon-options';
import { KzIconsRegistryService } from '../../icon/kz-icons-registry.service';
import { kzIconsArrowdown } from '../../icon/generated-icons/kzIcons-arrowdown.icon';

@Component({
  selector: 'kz-read-more-icon',
  host: {
    '[class]': '"kz-read-more-icon" + (classes ? " " + classes : "")',
  },
  template: `<button><kz-icons name="arrowdown"></kz-icons></button>`,
  styleUrls: ['./kz-read-more-icon.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KzReadMoreIconComponent implements OnInit, OnChanges {
  private _classes: string;

  get classes(): string {
    return this._classes;
  }

  private _readMoreContext: ReadMoreContext = 'default';

  get readMoreContext(): ReadMoreContext {
    return this._readMoreContext;
  }

  @Input()
  set readMoreContext(value: ReadMoreContext) {
    this._readMoreContext = value;
  }

  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private _kzIconsRegistryService: KzIconsRegistryService,
  ) {
    this._kzIconsRegistryService.registerIcons([kzIconsArrowdown]);
  }

  @HostBinding('class.open') get isOpened() {
    return this.opened;
  };

  @HostListener('click', ['$event', '$event.target'])
  onClick(event: MouseEvent, targetElement: HTMLElement): void {
    this.opened = !this.opened;
    this.openedChange.emit(this.opened);
  }

  @Input() opened = false;

  @Output()
  readonly openedChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  ngOnInit(): void {
    this._updateClasses();
    this._changeDetectorRef.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this._updateClasses();
    this._changeDetectorRef.detectChanges();
  }

  private _updateClasses() {
    this._classes = '';
    if (this.readMoreContext && this.readMoreContext !== 'default') {
      this._classes += ` kz-read-more-icon--${ this.readMoreContext }`;
    }
  }
}
